import Realistic from 'react-canvas-confetti/dist/presets/realistic';

function Confetti() {
  return <Realistic autorun={{ speed: 1, duration: 1 }} />;
}

export default Confetti;
